import Cropper from 'cropperjs';
import Exif from 'exif-js';
import {Toast} from 'vant';

export default {
    data() {
        return {
            photoType: 'image/png',
            //判断图片是否大于300k,不大于直接上传，反之压缩
            limtLen: 300 * 1024,
            isComfirm: true, // 防止连续点击确认，上传两张图片
        }
    },
    methods: {
        clipImage(file) {
            this.photoType = file.file.type; // 图片类型
            this.initilize();
            this.originUrl = file.content;
            //去获取拍照时的信息，解决拍出来的照片旋转问题
            // Exif.getData(file, _ => {
            //     this.Orientation = Exif.getTag(file, 'Orientation');
            // });
            //每次替换图片要重新得到新的url
            if (this.cropper) {
                this.cropper.replace(this.originUrl);
            }
        },
        initilize(opt) {
            let self = this;
            //创建dom
            this.idCardBox();
            //初始化裁剪对象
            this.cropper = new Cropper(this.preview, {
                aspectRatio: 'NaN', //最终生成图片的常高比
                viewMode: 1, //0：没有限制;1:裁剪框必须在图片内移动；2：2图片 不全部铺满1；3：图片填充整个裁剪框
                dragMode: 'move',//拖拽模式，只能移动裁剪框
                responsive: true, //调整窗口大小时，重新渲染cropper
                cropBoxResizable: false, //调整裁剪框大小
                autoCropArea: 0.01,  //自动裁剪面积大小和图片的对比
                center: false,
                cropBoxMovable: false, //是否允许移动裁剪框
                autoCrop: true, //初始化时，自动生成裁剪框
                background: false, //显示裁剪区域的背景方格
                modal: false,
                highlight: true,
                zoomOnWheel: true,  //是否可以通过移动鼠标放大图像
                zoomOnTouch: true, //是否可以通过拖动触摸放大图像
                zoomable: true,//是否允许放大图像
                movable: true, //是否允许移动后面的图片
                rotatable: true, //是否允许旋转图像
                scalable: true,//是否允许缩放图像
                resizable: true,
                guides: false,
                minContainerWidth: 200,//容器的最小宽度
                minContainerHeight: 100,//容器的最小高度
                minCropBoxWidth: 355,//裁剪层的最小宽度
                minCropBoxHeight: 250,//裁剪层的最小高度
                wheelZoomRatio: 0.1, //鼠标移动图像时，定义缩放比例
                ready: function () {
                    let cropBox = self.cropper.cropBox;
                    cropBox.querySelector('span.cropper-view-box').style.outline = 'none';
                    cropBox.querySelector('span.cropper-face').style.backgroundImage = "url(" + require('./bg.png') + ")";
                    cropBox.querySelector('span.cropper-face').style.backgroundColor = "transparent";
                    cropBox.querySelector('span.cropper-face').style.opacity = 1;
                    cropBox.querySelector('span.cropper-face').style.backgroundRepeat = "no-repeat";
                    cropBox.querySelector('span.cropper-face').style.backgroundSize = "100% 100%";
                }
            });
        },
        idCardBox() {
            //初始化图片为空对象
            this.preview = null;
            let str = `<div class="crop_main posbox">
               <img id="clip_image" /></div>
               <div class="" id="clip_rotate"><p>旋转</p></div>
               <div class="clip_bottom">
               <p>
               <span class="btn" id="cancel_clip">取消</span>
               <span class="btn" id="clip_restore">还原</span>
               <span class="btn" id="clip_button">确定</span>
               </p>
               </div>`;
            let body = document.getElementsByTagName('body')[0];
            this.reagion = document.createElement('div');
            this.reagion.id = 'clip_container';
            this.reagion.className = 'container';
            this.reagion.innerHTML = str;
            //添加创建好的DOM元素
            body.appendChild(this.reagion);
            this.preview = document.getElementById('clip_image');
            //绑定方法
            this.initFunc();
        },
        initFunc() {
            this.confirmBtn = document.getElementById('clip_button');
            this.cancelBtn = document.getElementById('cancel_clip');
            this.rotateBtn = document.getElementById('clip_rotate');
            this.restoreBtn = document.getElementById('clip_restore');
            //确定事件
            this.addEvent(this.confirmBtn, 'click', _ => {
                if (this.isComfirm) {
                    this.isComfirm = false;
                    this.ToastLoading = Toast.loading({
                        mask: true,
                        duration: 0,
                        message: '加载中...'
                    });

                    this.cropImage();
                }
            });
            //取消事件
            this.addEvent(this.cancelBtn, 'click', _ => {
                this.destoried();
            });
            // 旋转事件
            var current = 0;
            this.addEvent(this.rotateBtn, 'click', _ => {
                current++;
                this.cropper.rotate(90);
            });
            this.addEvent(this.restoreBtn, 'click', _ => {
                this.cropper.rotate(-current * 90);
                current = 0;
            });
        },
        getObjectURL(file) {
            // 图片转码方法
            let url = null;
            if (window.createObjectURL != undefined) { // basic
                url = window.createObjectURL(file);
            } else if (window.URL != undefined) { // mozilla(firefox)
                url = window.URL.createObjectURL(file);
            } else if (window.webkitURL != undefined) { // webkit or chrome
                url = window.webkitURL.createObjectURL(file);
            }
            console.log('url', url)
            return url;
        },
        cropImage() {
            // 点击确定进行裁剪
            let self = this;
            let image = new Image();

            let croppedCanvas;
            let roundedCanvas;

            // croppedCanvas = this.cropper.getCroppedCanvas();
            // roundedCanvas = this.getRoundedCanvas(croppedCanvas);
            //
            // let canvasUrl = roundedCanvas.toDataURL();
            // this.postImg(canvasUrl);

            setTimeout(_ => {
                croppedCanvas = this.cropper.getCroppedCanvas();
                roundedCanvas = this.getRoundedCanvas(croppedCanvas);

                let imgData = roundedCanvas.toDataURL();
                image.src = imgData;
                //判断图片是否大于300k,不大于直接上传，反之压缩
                if (imgData.length < this.limtLen) {

                    this.postImg(imgData);
                } else {
                    image.onload = function () {
                        //压缩处理
                        let data = self.compress(image, self.Orientation);
                        self.postImg(data);
                    }
                }
            }, 20);
        },
        getRoundedCanvas(sourceCanvas) {
            // 获取裁剪图片资源
            let canvas = document.createElement('canvas');
            let context = canvas.getContext('2d');
            let width = sourceCanvas.width;
            let height = sourceCanvas.height;

            canvas.width = width;
            canvas.height = height;

            context.imageSmoothingEnabled = true;
            context.drawImage(sourceCanvas, 0, 0, width, height);
            context.globalCompositeOperation = 'destination-in';
            context.beginPath();
            context.rect(0, 0, width, height);
            context.fill();

            return canvas;
        },
        destoried() {
            //移除事件
            this.removeEvent(this.confirmBtn, 'click', null);
            this.removeEvent(this.cancelBtn, 'click', null);
            this.removeEvent(this.rotateBtn, 'click', null);
            //移除裁剪框
            this.reagion.parentNode.removeChild(this.reagion);
            //销毁裁剪对象
            this.cropper.destroy();
            this.cropper = null;
        },
        postImg(dataUrl) {
            this.uploadOss(dataUrl);
            setTimeout(() => {
                //裁剪完后摧毁对象
                this.isComfirm = true;
                this.destoried();
            }, 3000)

        },
        rotateImg(img, direction, canvas) {
            //最小与最大旋转方向，图片旋转4次后回到原方向
            const min_step = 0;
            const max_step = 3;
            if (img == null) return;
            //img的高度和宽度不能在img元素隐藏后获取，否则会出错
            let height = img.height;
            let width = img.width;
            let step = 2;
            if (step == null) {
                step = min_step;
            }
            if (direction == 'right') {
                step++;
                //旋转到原位置，即超过最大值
                step > max_step && (step = min_step);
            } else {
                step--;
                step < min_step && (step = max_step);
            }
            //旋转角度以弧度值为参数
            let degree = step * 90 * Math.PI / 180;
            let ctx = canvas.getContext('2d');
            switch (step) {
                case 0:
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0);
                    break;
                case 1:
                    canvas.width = height;
                    canvas.height = width;
                    ctx.rotate(degree);
                    ctx.drawImage(img, 0, -height);
                    break;
                case 2:
                    canvas.width = width;
                    canvas.height = height;
                    ctx.rotate(degree);
                    ctx.drawImage(img, -width, -height);
                    break;
                case 3:
                    canvas.width = height;
                    canvas.height = width;
                    ctx.rotate(degree);
                    ctx.drawImage(img, -width, 0);
                    break;
            }
        },
        compress(img, Orientation) {
            // 图片压缩
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext('2d');
            //瓦片canvas
            let tCanvas = document.createElement("canvas");
            let tctx = tCanvas.getContext("2d");
            let initSize = img.src.length;
            let width = img.width;
            let height = img.height;

            //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
            let ratio;
            if ((ratio = width * height / 4000000) > 1) {
                ratio = Math.sqrt(ratio);
                width /= ratio;
                height /= ratio;
            } else {
                ratio = 1;
            }
            canvas.width = width;
            canvas.height = height;
            // 铺底色
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            //如果图片像素大于100万则使用瓦片绘制
            let count;
            if ((count = width * height / 1000000) > 1) {
                count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
                // 计算每块瓦片的宽和高
                let nw = ~~(width / count);
                let nh = ~~(height / count);
                tCanvas.width = nw;
                tCanvas.height = nh;
                for (let i = 0; i < count; i++) {
                    for (let j = 0; j < count; j++) {
                        tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
                        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
                    }
                }
            } else {
                ctx.drawImage(img, 0, 0, width, height);
            }
            //修复ios上传图片的时候 被旋转的问题
            if (Orientation != "" && Orientation != 1) {
                switch (Orientation) {
                    case 6://需要顺时针（向左）90度旋转
                        this.rotateImg(img, 'left', canvas);
                        break;
                    case 8://需要逆时针（向右）90度旋转
                        this.rotateImg(img, 'right', canvas);
                        break;
                    case 3://需要180度旋转
                        this.rotateImg(img, 'right', canvas);//转两次
                        this.rotateImg(img, 'right', canvas);
                        break;
                }
            }
            // return canvas.toDataURL(this.photoType);

            //  小于等于300k,换一个压缩比例
            let compres = [0.4, 0.5, 0.6, 0.7, 0.8];
            let compresData;
            for (let i = 0; i < compres.length; i++) {
                let minData = canvas.toDataURL(this.photoType, compres[i]);
                if (minData.length > this.limtLen) {
                    console.log('压缩质量', compres[i]);
                    compresData = minData;
                    break;
                }
            }
            if (!compresData) {
                compresData = canvas.toDataURL(this.photoType);
            }
            console.log('压缩前：' + initSize);
            console.log('压缩后：' + compresData.length);
            console.log('压缩率：' + ~~(100 * (initSize - compresData.length) / initSize) + "%");
            return compresData;
        },
        addEvent(obj, type, fn) {
            // 添加事件
            if (obj.addEventListener) {
                obj.addEventListener(type, fn, false);
            } else {
                obj.attachEvent('on' + type, fn);
            }
        },
        removeEvent(obj, type, fn) {
            // 移除事件
            if (obj.removeEventListener) {
                obj.removeEventListener(type, fn, false);
            } else {
                obj.detachEvent('on' + type, fn);
            }
        }
    }
}
